<div fxLayout="column" fxFlex>
  <div fxFlex class="registro-deviacion" fxLayout="column">
    <h1 mat-dialog-title>{{'desviationList.title' | translate}}</h1>
  </div>

  @if (data.create) {
    <div fxFlex>
      <div fxFlex="20">
        <button mat-raised-button color="primary" (click)="createNewDev()">{{ 'button.create.deviation' | translate }}</button>
      </div>
    </div>
  }

  <section fxLayout="column" class="table-container dev-container">
    <table #deviations mat-table matSort [dataSource]="this.data.deviations" >

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'desviationList.cols.code' | translate }} </th>
        <td mat-cell *matCellDef="let item"> {{ item.codeDeviation }} </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'desviationList.cols.status.label' | translate }} </th>
        <td mat-cell *matCellDef="let item"> {{ showStatusDeviation(item) }} </td>
      </ng-container>
      <ng-container matColumnDef="modDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'desviationList.cols.modDate' | translate }} </th>
        <td mat-cell *matCellDef="let item"> {{ item.modDate |fixDateTime }} </td>
      </ng-container>
      <ng-container matColumnDef="modUser">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'desviationList.cols.modUser' | translate }} </th>
        <td mat-cell *matCellDef="let item"> {{ item.modUser }} </td>
      </ng-container>
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
        <td mat-cell *matCellDef="let item; let devIndex = index">
          <button mat-icon-button (click)="showDeviationSelected(item?.uuid)">
            <mat-icon>mode_edit</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </section>

  <div mat-dialog-actions class="qualificates-theme">
    <div fxFlex></div>
    @if (data.create) {
      <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
    }
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.close' | translate }}</button>
  </div>
</div>